import Vue from 'vue'

const Component = Vue => {
  Vue.component('IcareTable', () => import('./IcareTable'))
}

Vue.use(Component)
